const Breakpoints = {
  base: 'base',
  mobile: 'mobile',
  tablet: 'tablet',
  desktop: 'desktop',
  desktopXL: 'desktopXL',
} as const;

export type Breakpoint = (typeof Breakpoints)[keyof typeof Breakpoints];

export const BREAKPOINTS_ORDER: Breakpoint[] = [
  Breakpoints.base,
  Breakpoints.mobile,
  Breakpoints.tablet,
  Breakpoints.desktop,
  Breakpoints.desktopXL,
];

/** Breakpoints that get mapped to min-width media queries. Leave base out as it is default */
export const BREAKPOINT_VALUES = ['320px', '768px', '1024px', '1440px'];
